<form [formGroup]="form" class="ml-form" fxLayout="column" [fxLayoutGap]="V_LYT_GAP">
  <div class="flex-wrap">
    <mat-form-field fxFlex>
      <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_TASE2_VERBINDUNGSNAME"
      [disabled]="!readonly && disabled"></redispatch-erzeugungsanlage-form-prefix>
      <mat-label>TASE.2-Verbindungsname</mat-label>
      <input matInput
        formControlName="tase2Verbindungsname"
        [redispatchDisableControl]="readonly || disabled"
        name="funkrundsteuerEmpfaengerInformationen_verbindungsname">
      @if (f.tase2Verbindungsname.hasError('required')) {
        <mat-error>
          Der TASE.2-Verbindungsname darf nicht leer sein
        </mat-error>
      }
      @if (f.tase2Verbindungsname.hasError('minlength')) {
        <mat-error>
          Der TASE.2-Verbindungsname muss aus mindestens einem Zeichen bestehen
        </mat-error>
      }
      @if (f.tase2Verbindungsname.hasError('maxlength')) {
        <mat-error>
          Der TASE.2-Verbindungsname darf aus maximal 16 Zeichen bestehen
        </mat-error>
      }
    </mat-form-field>

    <mat-form-field fxFlex="25">
      <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_TASE2_ABREGELUNGSTYP"
      [disabled]="!readonly && disabled"></redispatch-erzeugungsanlage-form-prefix>
      <mat-label>Abregelungstyp</mat-label>
      <mat-select
        [required]="true"
        [(ngModel)]="abregelungstyp"
        [ngModelOptions]="{ standalone: true }"
        [redispatchDisableControl]="readonly || disabled"
        (selectionChange)="f.tase2Verbindungsname.markAsDirty()">
        @for (typ of abregelungstypSelectionList; track typ.key) {
          <mat-option [value]="typ.key">{{ typ.description }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>


  <div class="div-table" formArrayName="adressen" fxLayout="column">

    <div class="header" fxLayout="row" fxFlex [fxLayoutGap]="LYT_GAP">
      <div [fxFlex]="COLS[0]">
        <span class="icon-text-combo">ADRESSIERUNG
          @if (getHilfetext(Feld.TABLEHEADER_TASE2_ADRESSIERUNG) | async; as text) {
            <mat-icon
              svgIcon="innogy_picto_speech-bubble_exclamationmark"
              aria-hidden="false"
              [attr.aria-label]="text"
              [matTooltip]="text"
              matTooltipPosition="right"
              matTooltipClass="multiline-tooltip"
            >
            </mat-icon>
          }
        </span>
      </div>
      <div [fxFlex]="COLS[1]">
        <span class="icon-text-combo bold">TASE.2-OBJEKT
          @if (getHilfetext(Feld.TABLEHEADER_TASE2_OBJEKT) | async; as text) {
            <mat-icon
              svgIcon="innogy_picto_speech-bubble_exclamationmark"
              aria-hidden="false"
              [attr.aria-label]="text"
              [matTooltip]="text"
              matTooltipPosition="right"
              matTooltipClass="multiline-tooltip"
            >
            </mat-icon>
          }
        </span>
      </div>
      <div [fxFlex]="COLS[2]">
        <span class="icon-text-combo">ELEMENTTYP
          @if (getHilfetext(Feld.TABLEHEADER_TASE2_ELEMENTTYP) | async; as text) {
            <mat-icon
              svgIcon="innogy_picto_speech-bubble_exclamationmark"
              aria-hidden="false"
              [attr.aria-label]="text"
              [matTooltip]="text"
              matTooltipPosition="right"
              matTooltipClass="multiline-tooltip"
            >
            </mat-icon>
          }
        </span>
      </div>
      <div [fxFlex]="COLS[3]"></div>
    </div>

    @for (adresse of fAdressen; track adresse; let isLast = $last) {
      <div
        [class.hidden]="isHidden(adresse.value.kopplungsTyp)" fxLayout="column" fxFlex data-qa="tase2-adresse">
        <redispatch-abregelinformationen-tase2-adresse [form]="adresse"
          [disabled]="disabled || isHidden(adresse.value.kopplungsTyp)"
          [readonly]="readonly">
        </redispatch-abregelinformationen-tase2-adresse>
        @if (!isLast) {
          <hr>
        }
      </div>
    }
    </div>
  </form>
